import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20acf54a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_wrap" }
const _hoisted_2 = { class: "main_content" }
const _hoisted_3 = { class: "info_title" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["id"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  name: "chooseAccount"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_8 = { class: "main_bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    "default-href": "/delete-account",
                    icon: _ctx.chevronBack,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss('close')))
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.surveyTitle), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveyItems, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v,
                  class: "select-account",
                  onClick: ($event: any) => (_ctx.dismiss(v.userWithdrawalSurveyItemId))
                }, [
                  _createElementVNode("label", {
                    id: v.userWithdrawalSurveyItemId,
                    class: "radio-container"
                  }, [
                    _hoisted_6,
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(v.description), 1)
                  ], 8, _hoisted_5)
                ], 8, _hoisted_4))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                class: "skip_text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dismiss(1)))
              }, "건너뛰기 >")
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}